// extracted by mini-css-extract-plugin
export default {"container":"header-module__container__cAsrh","title":"header-module__title__CJZ2a","wishlist":"header-module__wishlist__AokTv"};